// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"ce099317","417":"8fcb40ec","478":"122077f4","844":"0c87d8f0"}[chunkId] + ".chunk.js";
};